import { render, staticRenderFns } from "./TypeOfHeating.vue?vue&type=template&id=07816e5a&"
import script from "./TypeOfHeating.vue?vue&type=script&lang=ts&"
export * from "./TypeOfHeating.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports